import React from "react";
import { StorageDetailContainer } from "../../styled/pickUp";
import { Buttons } from "../../styled/common";

const AddServiceTime = ({
  transformValue,
  handleService,
  handleBackButton,
  serviceTime,
  setServiceTime,
  isService,
}) => {
  return (
    <StorageDetailContainer
      className="slideContent center"
      style={{ transform: `translateX(${transformValue}%)` }}>
      <div className="modalTit">서비스 시간 {serviceTime}분을 추가하시겠습니까?</div>
      <div className="paymentMethod">
        <div className="con">
          <label htmlFor="serviceTime-10">
            <input
              type="radio"
              name="serviceTime"
              id="serviceTime-10"
              value={"10"}
              checked={serviceTime === "10"}
              onChange={(e) => setServiceTime(e.target.value)}
            />
            <span className="checkmark"></span>
          </label>
          <span>10분</span>
          <label htmlFor="serviceTime-60">
            <input
              type="radio"
              name="serviceTime"
              id="serviceTime-60"
              value={"60"}
              checked={serviceTime === "60"}
              onChange={(e) => setServiceTime(e.target.value)}
            />
            <span className="checkmark"></span>
          </label>
          <span>60분</span>
        </div>
      </div>

      <Buttons>
        <button onClick={handleBackButton}>취소</button>
        <button onClick={handleService} disabled={isService?.current}>
          확인
        </button>
      </Buttons>
    </StorageDetailContainer>
  );
};

export default AddServiceTime;
